/**
 * Rebonds du logo du fond « Logo DVD » : durées des deux allers-retours (horizontal et vertical) et couleurs à chaque rebond.
 * Aucun dessin, seulement du calcul (donc testable).
 *
 * Le logo avance à vitesse constante, mais bien plus vite à l'horizontale qu'à la verticale : le bandeau est bien plus large que
 * haut, et à vitesse égale le logo ne ferait que monter et descendre. Ici il file sur les côtés et ne bouge que doucement en hauteur. Les durées se calculent sur un bandeau de
 * référence de 1 080 × 112 px (le bandeau réel peut être plus large : le logo va alors un peu plus vite, sans importance).
 * Le trajet horizontal dure un nombre ENTIER de trajets verticaux, pour que la boucle se referme et que chaque changement de
 * couleur tombe exactement sur un rebond.
 */

export const REF_LARGEUR = 1080;
export const REF_HAUTEUR = 112;
export const VITESSE_X = 160;       // pixels par seconde à ×1, à l'horizontale
export const VITESSE_Y = 40;        // pixels par seconde à ×1, à la verticale

/** {tx, ty, n} : durée d'un trajet horizontal, d'un trajet vertical (secondes) et nombre de trajets verticaux par trajet horizontal. */
export function durees(vitesse, largeurLogo, hauteurLogo) {
    const ty = Math.max(0.2, (REF_HAUTEUR - hauteurLogo) / (VITESSE_Y * vitesse));
    const brut = Math.max(0, REF_LARGEUR - largeurLogo) / (VITESSE_X * vitesse);
    const n = Math.max(1, Math.round(brut / ty));
    return {tx: n * ty, ty, n};
}

/** Pas de teinte entre deux couleurs successives (degrés) : premier avec 360, donc toutes les couleurs défilent. */
export const PAS_TEINTE = 67;

/**
 * Image clés (texte CSS) d'une animation de couleur qui change à chaque rebond vertical : `2 n` rebonds par boucle (un aller-retour
 * horizontal complet), la couleur reste fixe entre deux rebonds (à utiliser avec `step-end`).
 */
export function imagesClesCouleur(nom, n) {
    const etapes = 2 * n;
    const images = Array.from({length: etapes}, (_, k) => `${((k / etapes) * 100).toFixed(4)}%{filter:hue-rotate(${(k * PAS_TEINTE) % 360}deg)}`);
    return `@keyframes ${nom}{${images.join("")}}`;
}
